var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgConnection = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "transparent",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 12H9.88a2 2 0 0 0-1.214-1.214v-2.12h4.667a.667.667 0 1 0 0-1.333h-.667v-4a2 2 0 0 0-2-2H5.333a2 2 0 0 0-2 2v4h-.667a.667.667 0 0 0 0 1.333h4.667v2.12A2 2 0 0 0 6.12 12H2a.667.667 0 1 0 0 1.333h4.12a2 2 0 0 0 3.76 0H14A.666.666 0 1 0 14 12ZM4.666 7.333v-4a.667.667 0 0 1 .667-.667h5.333a.666.666 0 0 1 .667.667v4H4.666Zm3.334 6a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334Z",
  fill: "currentColor"
})));

export default SvgConnection;